import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Login from './views/Login.vue'
import AdminInfo from './views/adminInfo.vue'
import FriendChat from './views/log/chat'
import Chatgpt from './views/chatgpt'
import Pay from './views/pay'
import SaasPay from './views/saaspay'
import Itemshop from './views/itemshop'
import AiImage from './views/chatgpt/image'
import AiTxt from './views/chatgpt/txt'
import AiTune from './views/chatgpt/tune'
import AiTuneFile from './views/chatgpt/tune_file'
import MyPage from './views/chatgpt/my'
import ShengyismartPay from './views/ShengyismartPay'
import Testsocket from './views/testsocket'
import Deepseek from './views/deepseek'
import Upay from './views/upay'
import Strippay from './views/strippay'
import Paymentsuccess from './views/stripepaymentsuccess'
import AddAccount from './views/AddAccount'
import BluePay from './views/bluepay'
import Payselect from './views/payselect'
import { GroupSelect } from '@/views/groupSelect' ;




// 布局组件
import MainLayout from './components/Layout/MainLayout'

// 页面组件
import ShopHome from './views/shop/Home'
import ProductDetail from './views/shop/ProductDetail'
import Cart from './views/shop/Cart'
import Checkout from './views/shop/Checkout'

// 认证页面
import ShopLogin from './views/shop/Auth/Login'
import Register from './views/shop/Auth/Register'

// 信息页面
import AboutUs from './views/shop/Info/AboutUs'
import FAQ from './views/shop/Info/FAQ'
import PrivacyPolicy from './views/shop/Info/PrivacyPolicy'
import RefundPolicy from './views/shop/Info/RefundPolicy'
import ContactUs from './views/shop/Info/ContactUs'
import TermsOfService from './views/shop/Info/TermsOfService'
import CookiePolicy from './views/shop/Info/CookiePolicy'



Vue.use(Router)

//添加以下代码  防止重复点击一个菜单引起的异常
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}


export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior() {
        return { x: 0, y: 0 }
    },
    routes: [
         {
            path: '/',
            name: 'CC谷',
          //  component: () => import('@/views/itemshop'),
           // component: () => import('@/views/AddAccount'),
            // component: () => import('@/views/bluepay'),//蓝新支付  pay.ccmaple.cc
            component: () => import('@/views/payselect'),//usdt和支付宝微信,   usdt.ccmaple.cc
           //component:  () => import('@/views/groupSelect'), //qqqun和dis群   group.ccmaple.cc
           hidden: true
         },
        { path: 'ShopHome', name: 'ShopHome', component: ShopHome },
        { path: 'product/:id', name: 'ProductDetail', component: ProductDetail },
        { path: 'cart', name: 'Cart', component: Cart },
        { path: 'checkout', name: 'Checkout', component: Checkout },
        // 信息页面路由
        { path: 'about-us', name: 'AboutUs', component: AboutUs },
        { path: 'faq', name: 'FAQ', component: FAQ },
        { path: 'privacy-policy', name: 'PrivacyPolicy', component: PrivacyPolicy },
        { path: 'refund-policy', name: 'RefundPolicy', component: RefundPolicy },
        { path: 'contact-us', name: 'ContactUs', component: ContactUs },
        { path: 'terms-of-service', name: 'TermsOfService', component: TermsOfService },
        { path: 'cookie-policy', name: 'CookiePolicy', component: CookiePolicy },
        // 登录注册路由
        { path: 'login', name: 'Login', component: ShopLogin },
        { path: 'register', name: 'Register', component: Register },
         {
            path: '/Upay',
            name: '谷',
            component: Upay,
            hidden: true
        },
        {
            path: '/Strippay',
            name: 'strip',
            component: Strippay,
            hidden: true
        },{
            path: '/paymentsuccess',
            name: 'paymentsuccess',
            component: Paymentsuccess,
            hidden: true
        
        }
        /**{
            path: '/',
            name: '道具商城',
            component: Testsocket,
            hidden: true
         }*/
      /**   {
            path: '/',
            name: '道具商城',
            component: Itemshop,
            hidden: true
         }*/
        /**
         * {
           path: '/',
           name: '充值平台',
           component: Pay,
           hidden: true
        }*/
         
        /**
         * {
            path:'/',
            name:'充值平台',
            component:SaasPay,
            hidden:true
        }*/
        /*
        {
            //path: '/',
            //name: 'Login',
            //component: Login,
           //hidden: true
           path: '/',
            name: '在线聊天',
            component: FriendChat,
            hidden: true
        }*//*  {
            //path: '/',
            //name: 'Login',
            //component: Login,
           //hidden: true
           path: '/',
           name: 'chatgpt',
           component: Chatgpt,
           redirect:'/txt',
           hidden: true,
           children: [
           {
                path:'/image',
                name: 'AI图片',
                component: AiImage,
                hidden: true
            },{
                path:'/txt',
                name: 'AI知识',
                component: AiTxt,
                hidden: true
            },{
                path:'/tune',
                name: 'AI训练',
                component: AiTune,
                hidden: true
            },{
                path:'/tuneFile',
                name:'AI训练素材',
                component:AiTuneFile,
                hidden:true
            },{
                path:'/my',
                name:'我的',
                component:MyPage,
                hidden:true
            }
        ]
       }*/, {
            path: '/home',
            name: 'Home',
            component: Home,
            hidden: true,
            meta: {
                roles: ['admin', 'user']
            },
            children: [
                {
                    path: '/chat',
                    name: '在线聊天',
                    component: FriendChat,
                    hidden: true
                }, 
                {
                    path: '/chatgpt',
                    name: '人工智能',
                    component: Chatgpt,
                    hidden: true
                },
                {
                    path: '/adminInfo',
                    name: '个人中心',
                    component: AdminInfo,
                    hidden: true
                },{
                    path:'/image',
                    name: 'AI图片',
                    component: AiImage,
                    hidden: true
                },{
                    path:'/txt',
                    name: 'AI知识',
                    component: AiTxt,
                    hidden: true
                }
            ]
        }
    ]
})